// extracted by mini-css-extract-plugin
export default {"App":"app_App__W-Szi","content":"app_content__VUgwH"};